import { PAYMENT_GATEWAY } from '@/constants'

export const TEST_TICKETING_CREDIT_CARD = {
	bin: '411111',
	expirationMonth: '03',
	expirationYear: '34',
	lastFour: '1111',
	paymentGatewayType: 'CreditCard',
	paymentProvider: 2,
	// Token will be valid until 2028-02-14T00:00:00.0000000
	token:
		'FA8201BDDFE0012438383432353235652D633065652D346666632D383832382D643233643731393736336665DFE00205312E352E30DFE0041B323032382D30322D31345430303A30303A30302E30303030303030DFE0050450726F64DFE0061C323032352D30322D31345430383A34353A30332E373034303330315ADFE0070A4F513034323233343735DFE0080731303031373639DFE0092434363530376536652D663462662D343536662D626332622D636138336164303733313134DFE01140044208A9D436C7324440857107970924BBE26FA7E8435DD5E957220C6AEC4E4EC1221FBC9014FF44F8504C1D624D90913BC280215F1FD51A956CBD996CF68B8FDFE0120A90114000000028A924FEDFE014023634DFE0212E5445436F6E6E6563742D34363433656639332D626633352D343565622D396436352D343266313439643639346664DFE0250135DFE0264D7B224D61736B656450414E223A223431313131312A2A2A2A2A2A31313131222C2245787069726174696F6E44617465223A2233343033222C2242696C6C696E675A4950223A223333343434227DDFE00320098C2BFCC19B43FC69F1A97AC0461BECFFD52E6811ACDE8B34B1FCF54E983124'
}

export const buildTicketingFakeCreditCard = (paymentMethod: string) => ({
	...TEST_TICKETING_CREDIT_CARD,
	// Keep gateway type as CreditCard for fake/demo token compatibility.
	paymentGatewayType: PAYMENT_GATEWAY.CREDIT_CARD,
	cardHolderName: paymentMethod || PAYMENT_GATEWAY.CREDIT_CARD
})
